export default __webpack_public_path__ + "static/media/agencia.de27fb70.png";